import TestimonialSlider from "@components/TestimonialSlider";
import {NextPage} from "next";
import {useTranslation} from "ni18n";
import React from "react";
import About from "src/components/v5/CarbonForCampus/About";
import Benefits from "src/components/v5/CarbonForCampus/Benefits";
import Contact from "src/components/v5/CarbonForCampus/Contact";
import Hero from "src/components/v5/CarbonForCampus/Hero";
import Overview from "src/components/v5/CarbonForCampus/Overview";
import Faq from "src/components/v5/Faq/Faq";
import Layout from "src/components/v5/Layout";
import {useCarbonForCampusConstants} from "src/constants/CarbonForCampus";

const CarbonForCampus: NextPage = () => {
  const i18n = useTranslation();

  const {faq, testimonials} = useCarbonForCampusConstants();

  const pageTitle = "Carbon for Campus";
  const pageDescription = i18n.t(
    "Carbon for Campus partners with colleges to offer comprehensive care, flexible options, and lower costs.",
  );
  const ogAlt = i18n.t(
    "Photo of an office lobby. It’s bright, clean, and modern, with colorful chairs and healthy plants.",
  );

  return (
    <Layout
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage="carbon-for-campus-2"
      ogAlt={ogAlt}
    >
      <Hero />
      <About />
      <Benefits />
      <Overview />
      <TestimonialSlider
        defaultTestimons={testimonials}
        defaultHead={i18n.t("What our clients say")}
      />
      <Contact />
      <Faq faq={faq} />
    </Layout>
  );
};

export default CarbonForCampus;
